import React from "react"
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

export default function Slide() {    
    return (
        <div
            style={{
                width: '80%',
                paddingTop: '2rem',
                margin: 'auto'
            }}
        >
            <Carousel
                autoPlay={true}
                showThumbs={false}
                interval={2000}
                transitionTime={800}
                renderIndicator={false}  
                infiniteLoop={true}                 
            >
                <div>
                    <img src={require('../assets/slide1.jpg')} alt="slide1"/>                
                </div>
                <div>
                    <img src={require('../assets/slide2.jpg')} alt="slide2"/>
                </div>
                <div>
                    <img src={require('../assets/slide3.jpg')} alt="slide3"/>              
                </div>
                <div>
                    <img src={require('../assets/slide4.jpg')} alt="slide4"/>              
                </div>
            </Carousel>   
        </div>    
          
    )
}